// Sort dropdown functionality
document.addEventListener('DOMContentLoaded', function() {
  const sortLinks = document.querySelectorAll('[data-sort-link]');
  const sortButtonText = document.querySelector('[data-sort-button-text]');
  
  if (sortLinks.length === 0) {
    return;
  }
  
  sortLinks.forEach((link, index) => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const sortValue = link.getAttribute('data-value');
      const sortText = link.textContent.trim();
      
      // Keep button text as "SORT" always - don't change it to selected option
      if (sortButtonText) {
        sortButtonText.textContent = 'SORT';
      }
      
      // Build URL with sort parameter
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortValue);
      
      window.location.href = url.toString();
    });
  });
});